<template>
    <div class="pickGamesList">
        <div>
            <h3 class="steps-title">Add a game from "All games" list or remove it from "Picked Games" list</h3>
            <div class="games-container">
                <div class="picked-container">
                    <h4 class="list-title">Picked games({{ filteredPickedGames.length }})</h4>
                    <input
                        v-if="pickedGames.length"
                        type="text"
                        class="form__input"
                        v-bind:value="pickedSearch"
                        v-on:input="onPickedSearch($event.target.value.trim())"
                        placeholder="search by slug"
                    />
                    <ul v-if="pickedGames.length" class="games-list">
                        <li v-for="pickedGame in pickedSearch ? searchedPickedGames : filteredPickedGames">
                            <span class="picked-game-title">{{ pickedGame }}</span>
                            <span class="picked-game-remove" @click="onRemovePickedGame(pickedGame)"
                                ><CloseIcon
                            /></span>
                        </li>
                    </ul>
                    <div :class="{ 'buttons-container': true, end: !pickedSearch }">
                        <button
                            class="ark-btn ark-btn--danger"
                            v-if="pickedGames.length && pickedSearch"
                            @click="onRemoveSearchedPickedGames()"
                        >
                            Remove Searched
                        </button>
                        <button
                            class="ark-btn ark-btn--danger"
                            v-if="pickedGames.length"
                            @click="onRemoveAllPickedGames()"
                        >
                            Remove All
                        </button>
                    </div>
                </div>
                <div class="all-games-container">
                    <h4 class="list-title">
                        All games list that could be added in "Picked games" list({{
                            allGames.length - filteredPickedGames.length
                        }})
                    </h4>
                    <input
                        v-if="allGames.length"
                        type="text"
                        class="form__input"
                        v-bind:value="allGamesSearch"
                        v-on:input="onAllGamesSearch($event.target.value.trim())"
                        placeholder="search by slug"
                    />
                    <ul v-if="allGames.length" class="games-list">
                        <li v-for="game in allGamesSearch ? searchedAllGames : filteredAllGames">
                            <span class="picked-game-title">{{ game }}</span>
                            <button @click="onAddGame(game)"><AddIcon /></button>
                        </li>
                    </ul>
                    <div :class="{ 'buttons-container': true, end: !allGamesSearch }">
                        <button
                            class="ark-btn ark-btn--success"
                            v-if="allGames.length && allGamesSearch"
                            @click="onAddSearchedAllGames()"
                        >
                            Add Searched
                        </button>
                        <button class="ark-btn ark-btn--success" v-if="allGames.length" @click="onAddAllGames()">
                            Add All
                        </button>
                    </div>
                </div>
            </div>

            <h3 v-if="pickedGames.length" class="steps-title">Click "Save" to save changes</h3>
            <div v-if="$checkRoles(['Administrator']) && pickedGames.length" class="button-save-container">
                <button @click="onSaveClick()" class="ark-btn ark-btn--default">Save</button>
            </div>
        </div>
    </div>
</template>

<script>
import InfoModal from '../InfoModal/InfoModal.vue';
import CloseIcon from '../CloseIcon/CloseIcon.vue';
import AddIcon from '../AddIcon/AddIcon.vue';
export default {
    name: 'PickGamesList',
    components: { CloseIcon, AddIcon, InfoModal },
    props: ['pickedGames', 'allGames', 'onSave'],

    data() {
        return {
            filteredAllGames: [],
            filteredPickedGames: [],
            searchedAllGames: [],
            searchedPickedGames: [],
            pickedSearch: null,
            allGamesSearch: null,
        };
    },

    methods: {
        onUpdateAllGames: function (newAllGames) {
            if (newAllGames.length) {
                this.filteredAllGames = newAllGames.filter((g) => !this.pickedGames.includes(g));
            }
        },
        onPickedSearch: function (value) {
            this.pickedSearch = value;
        },

        onAllGamesSearch: function (value) {
            this.allGamesSearch = value;
        },
        onRemovePickedGame: function (removedGame) {
            this.filteredPickedGames = this.filteredPickedGames.filter((g) => g !== removedGame);
            this.filteredAllGames.push(removedGame);

            if (this.searchedPickedGames.length) {
                this.searchedPickedGames = this.searchedPickedGames.filter((g) => g !== removedGame);
            }
            if (removedGame.includes(this.allGamesSearch)) {
                this.searchedAllGames.push(removedGame);
            }
        },
        onAddGame: function (addedGame) {
            this.filteredAllGames = this.filteredAllGames.filter((g) => g !== addedGame);

            if (this.searchedAllGames.length) {
                this.searchedAllGames = this.searchedAllGames.filter((g) => g !== addedGame);
            }

            this.filteredPickedGames.push(addedGame);
            if (addedGame.includes(this.pickedSearch)) {
                this.searchedPickedGames.push(addedGame);
            }
        },
        onRemoveSearchedPickedGames: function () {
            this.filteredPickedGames = this.filteredPickedGames.filter((g) => !this.searchedPickedGames.includes(g));
            this.filteredAllGames.push(...this.searchedPickedGames);
            this.searchedPickedGames.forEach((g) => {
                if (g.includes(this.allGamesSearch)) {
                    this.searchedAllGames.push(g);
                }
            });
            this.searchedPickedGames = [];
            this.pickedSearch = null;
        },
        onRemoveAllPickedGames: function () {
            this.filteredAllGames.push(...this.filteredPickedGames);
            if (this.searchedAllGames.length) {
                this.searchedAllGames.push(...this.filteredPickedGames);
            }
            this.filteredPickedGames = [];
            if (this.searchedPickedGames.length) {
                this.searchedPickedGames = [];
                this.pickedSearch = null;
                this.allGamesSearch = null;
            }
        },
        onAddSearchedAllGames: function () {
            this.filteredPickedGames.push(...this.searchedAllGames);
            this.filteredAllGames = this.filteredAllGames.filter((g) => !this.searchedAllGames.includes(g));
            this.searchedAllGames.forEach((g) => {
                if (g.includes(this.pickedSearch)) {
                    this.searchedPickedGames.push(g);
                }
            });
            this.searchedAllGames = [];
            this.allGamesSearch = null;
        },
        onAddAllGames: function () {
            this.filteredPickedGames.push(...this.filteredAllGames);
            if (this.searchedPickedGames.length) {
                this.searchedPickedGames.push(...this.filteredAllGames);
            }
            this.filteredAllGames = [];
            if (this.searchedAllGames.length) {
                this.searchedAllGames = [];
                this.pickedSearch = null;
                this.allGamesSearch = null;
            }
        },

        onSaveClick: function () {
            this.onSave(this.filteredPickedGames);
        },
    },
    watch: {
        allGames: {
            immediate: true,
            handler(newAllGames) {
                this.onUpdateAllGames(newAllGames);
            },
        },
        pickedGames: {
            handler(newPickedGames) {
                this.filteredPickedGames = newPickedGames;
                this.filteredAllGames = this.allGames.filter((g) => !newPickedGames.includes(g));
            },
        },
        pickedSearch: {
            handler(newValue) {
                if (!newValue) {
                    this.searchedPickedGames = this.filteredPickedGames;
                }
                this.searchedPickedGames = this.filteredPickedGames.filter((g) => g.includes(newValue));
            },
        },
        allGamesSearch: {
            handler(newValue) {
                if (!newValue) {
                    this.searchedAllGames = this.filteredAllGames;
                }
                this.searchedAllGames = this.filteredAllGames.filter((g) => g.includes(newValue));
            },
        },
    },
};
</script>

<style scoped src="./pickGamesList.scss" lang="scss"></style>
